import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AwscontrolService, UploadResponse, DeleteResponse } from 'app/services/aws/awscontrol.service'; // Import AWS service

import { BiensImmobs } from 'app/models/biensImmobs';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { BiensImmobsBiensImmobs } from 'app/services/biens-immobs/biens-immobs.service';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-ajouter-meilleurs-biens',
  templateUrl: './ajouter-meilleurs-biens.component.html',
  styleUrls: ['./ajouter-meilleurs-biens.component.scss']
})
export class AjouterMeilleursBiensComponent implements OnInit {
  @ViewChild('descriptionTextarea', { static: false }) descriptionTextarea!: ElementRef;
  @ViewChild('agencySelect') agencySelect!: MatSelect;
  @ViewChild('agencySearchInput') agencySearchInput!: ElementRef;

  // Form data
  biensImmob: BiensImmobs;
  
  // File upload
  selectedFiles: FileList;
  promoSelectedFiles: FileList;
  allAttch: string[] = [];
  promoAttch: string[] = [];
  
  // Images
  public image!: string;
  public imagePromo!: string;
  
  // Agencies
  agenciesApp: any;
  selectedAgencyName: string = '';
  
  // Agency search functionality
  public agencySearch: string = '';
  public filteredAgencies: any[] = [];
  public allAgencies: any[] = [];
  public isAgencySelectOpen: boolean = false;
  
  // Categories
  public categoryInput: string = '';
  
  // Other
  NameAgence: any;
  idItem: any;
  idA: any;
  NameAgence1: any;
  public biens: any;

  constructor(
    private router: Router,
    public location: Location,
    private agenciesService: AgenciesService,
    private bienImmobService: BiensImmobsBiensImmobs,
    private awsService: AwscontrolService // Inject AWS service
  ) { 
    this.biensImmob = new BiensImmobs();
    this.selectedFiles = null!;
    this.promoSelectedFiles = null!;
  }

  ngOnInit(): void {
    this.clearStoredImages();
    this.getData();
    
    this.agenciesService.getId().subscribe((data: any) => {
      this.idA = data;
      console.log('Agency ID:', this.idA);
    });
    
    this.retrieveStoredItemId();
    this.AgencyNameById();
    this.AgencyNameById1();
  }

  // Formatage du texte dans la description
  formatText(command: string): void {
    if (this.descriptionTextarea) {
      const textarea = this.descriptionTextarea.nativeElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selectedText = this.biensImmob.description.substring(start, end);
      
      let formattedText = '';
      switch (command) {
        case 'bold':
          formattedText = `<strong>${selectedText}</strong>`;
          break;
        case 'italic':
          formattedText = `<em>${selectedText}</em>`;
          break;
        case 'underline':
          formattedText = `<u>${selectedText}</u>`;
          break;
      }
      
      const newText = this.biensImmob.description.substring(0, start) + 
                     formattedText + 
                     this.biensImmob.description.substring(end);
      
      this.biensImmob.description = newText;
      
      // Set focus back to textarea
      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(start + formattedText.length, start + formattedText.length);
      }, 0);
    }
  }

  // Gestion des catégories
  addCategory(): void {
    if (this.categoryInput && this.categoryInput.trim() !== '') {
      if (!this.biensImmob.categoryList) {
        this.biensImmob.categoryList = [];
      }
      
      // Check if category already exists
      if (!this.biensImmob.categoryList.includes(this.categoryInput.trim())) {
        this.biensImmob.categoryList.push(this.categoryInput.trim());
      }
      
      this.categoryInput = '';
    }
  }

  removeCategory(category: string): void {
    if (this.biensImmob.categoryList) {
      const index = this.biensImmob.categoryList.indexOf(category);
      if (index >= 0) {
        this.biensImmob.categoryList.splice(index, 1);
      }
    }
  }

  // Charger les agences avec rôle "meilleurs-biens"
  getData() {
    this.getAllAgencies();
  }

  getAllAgencies() {
    this.agenciesService.getList().subscribe({
      next: (data: any) => {
        let agencies = [];
        
        if (Array.isArray(data)) {
          agencies = data;
        } else if (data && typeof data === 'object') {
          agencies = [data];
        } else {
          agencies = [];
        }
        
        // Filtrer uniquement les agences avec rôle "meilleurs-biens"
        this.allAgencies = agencies
          .filter(agency => 
            agency && 
            agency.name && 
            typeof agency.name === 'string' &&
           (agency.role =='meilleurs-biens')
          )
          .map(agency => ({
            id: agency.id,
            name: agency.name.trim(),
            initial: this.getInitial(agency.name),
            color: this.getRandomColor()
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        
        this.filteredAgencies = [...this.allAgencies];
        
        console.log('Agences "meilleurs-biens" chargées:', this.allAgencies.length);
        
        if (this.allAgencies.length === 0) {
          Swal.fire({
            icon: 'info',
            title: 'Aucune agence disponible',
            text: 'Aucune agence avec le rôle "meilleurs-biens" n\'a été trouvée. Créez d\'abord une agence avec ce rôle.',
            timer: 3000
          });
        }
      },
      error: (error) => {
        console.error('Erreur lors du chargement des agences:', error);
        this.allAgencies = [];
        this.filteredAgencies = [];
        Swal.fire({
          icon: 'error',
          title: 'Erreur de chargement',
          text: 'Impossible de charger la liste des agences'
        });
      }
    });
  }

  // Helper methods for agency display
  private getInitial(name: string): string {
    return name ? name.trim().charAt(0).toUpperCase() : '?';
  }

  private getRandomColor(): string {
    const colors = [
      '#FF6B6B', '#4ECDC4', '#FFD166', '#06D6A0', '#118AB2',
      '#EF476F', '#7B68EE', '#20B2AA', '#FFA07A', '#9370DB'
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  // Gestion du sélecteur d'agence
  onAgencySelectOpened(): void {
    this.isAgencySelectOpen = true;
    this.agencySearch = '';
    this.filterAgencies();
    
    // Focus sur la barre de recherche après l'ouverture
    setTimeout(() => {
      if (this.agencySearchInput) {
        this.agencySearchInput.nativeElement.focus();
      }
    }, 100);
  }

  onAgencySelectClosed(): void {
    this.isAgencySelectOpen = false;
    this.agencySearch = '';
    this.filterAgencies();
  }

  // Filtrer les agences par recherche
  filterAgencies(): void {
    if (!this.agencySearch || this.agencySearch.trim() === '') {
      this.filteredAgencies = [...this.allAgencies];
    } else {
      const searchTerm = this.agencySearch.toLowerCase().trim();
      this.filteredAgencies = this.allAgencies.filter(agency => {
        if (!agency || !agency.name) return false;
        return agency.name.toLowerCase().includes(searchTerm);
      });
    }
  }

  // Effacer la recherche d'agences
  clearAgencySearch(): void {
    this.agencySearch = '';
    this.filterAgencies();
    
    // Re-focus sur la barre de recherche
    if (this.agencySearchInput) {
      this.agencySearchInput.nativeElement.focus();
    }
  }

  // Sélectionner une agence
  selectAgency(agency: any): void {
    this.selectedAgencyName = agency.name;
    this.agencySelect.close();
  }

  // Image upload methods
  public getRandomString(length: number): string {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  // Upload multiple images using AWS service
  uploadimg2() {
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      // Convert FileList to array
      const filesArray: File[] = [];
      for (let i = 0; i < this.selectedFiles.length; i++) {
        filesArray.push(this.selectedFiles[i]);
      }
      
      this.uploadFilesimg2(filesArray);
    }
  }

  selectFileimg(e: any) {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    
    // Validate file size (max 5MB)
    for (let i = 0; i < files.length; i++) {
      if (files[i].size > 5 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Fichier trop volumineux",
          text: `L'image ${files[i].name} dépasse la taille maximale de 5MB`,
        });
        return;
      }
    }
    
    this.selectedFiles = files;
    this.uploadimg2();
  }

  uploadFilesimg2(files: File[]): void {
    // Generate unique file names
    const renamedFiles = files.map(file => {
      const newName = `bien-images/${this.getRandomString(5)}_${file.name}`;
      return new File([file], newName, { type: file.type });
    });

    this.awsService.uploadFiles(renamedFiles, 'bien-images').subscribe({
      next: (response: UploadResponse) => {
        if (response.success) {
          console.log('Images uploaded:', response.urls);
          
          // Add all uploaded URLs to array
          response.urls.forEach(url => {
            this.allAttch.push(url);
          });
          
          // Stocker dans localStorage
          localStorage.setItem('bienImage', JSON.stringify(this.allAttch));
          
          // Set first image as main image
          if (this.allAttch.length > 0) {
            this.image = this.allAttch[0];
          }
          
          Swal.fire({
            icon: "success",
            title: "Images ajoutées",
            text: `${response.count} image(s) téléchargée(s) avec succès`,
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Erreur de téléchargement",
            text: response.error || "Échec du téléchargement des images",
          });
        }
      },
      error: (err: any) => {
        console.error('Error uploading images:', err);
        Swal.fire({
          icon: "error",
          title: "Erreur de téléchargement",
          text: "Échec du téléchargement des images. Veuillez réessayer.",
        });
      }
    });
  }

  // Upload promo image using AWS service
  uploadimgPromo() {
    if (this.promoSelectedFiles && this.promoSelectedFiles.length > 0) {
      const file = this.promoSelectedFiles[0];
      this.uploadFileimgPromo(file);
    }
  }

  selectFileimgPromo(e: any) {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    
    const file = files[0];
    
    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "Fichier trop volumineux",
        text: `L'image ${file.name} dépasse la taille maximale de 5MB`,
      });
      return;
    }
    
    this.promoSelectedFiles = files;
    this.uploadimgPromo();
  }

  uploadFileimgPromo(file: File): void {
    // Generate unique file name
    const renamedFile = new File([file], `bien-promo-images/${this.getRandomString(5)}_${file.name}`, { 
      type: file.type 
    });

    this.awsService.uploadFile(renamedFile, 'bien-promo-images').subscribe({
      next: (response: UploadResponse) => {
        if (response.success && response.urls.length > 0) {
          console.log('Promo image uploaded:', response.urls[0]);
          
          // Stocker dans localStorage
          localStorage.setItem('promoBien', JSON.stringify(response.urls[0]));
          
          // Mettre à jour les variables locales
          this.promoAttch = [response.urls[0]];
          this.imagePromo = response.urls[0];
          
          Swal.fire({
            icon: "success",
            title: "Image promotionnelle ajoutée",
            text: "L'image promotionnelle a été uploadée avec succès",
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Erreur de téléchargement",
            text: response.error || "Échec du téléchargement de l'image promotionnelle",
          });
        }
      },
      error: (err: any) => {
        console.error('Error uploading promo image:', err);
        Swal.fire({
          icon: "error",
          title: "Erreur de téléchargement",
          text: "Échec du téléchargement de l'image promotionnelle.",
        });
      }
    });
  }

  // Image management methods
  removeProjectImage(index: number): void {
    const imageUrl = this.allAttch[index];
    
    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Voulez-vous vraiment supprimer cette image?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        // Delete from S3
        this.awsService.deleteFile(imageUrl).subscribe({
          next: (response: DeleteResponse) => {
            if (response.status === 'success') {
              // Remove from array
              this.allAttch.splice(index, 1);
              localStorage.setItem('bienImage', JSON.stringify(this.allAttch));
              
              Swal.fire({
                icon: "success",
                title: "Image supprimée",
                text: "L'image a été supprimée avec succès",
                timer: 2000,
                showConfirmButton: false
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erreur",
                text: response.error || "Échec de la suppression de l'image",
              });
            }
          },
          error: (err: any) => {
            console.error('Error deleting image:', err);
            Swal.fire({
              icon: "error",
              title: "Erreur",
              text: "Échec de la suppression de l'image. Veuillez réessayer.",
            });
          }
        });
      }
    });
  }

  moveImageUp(index: number): void {
    if (index > 0) {
      const temp = this.allAttch[index];
      this.allAttch[index] = this.allAttch[index - 1];
      this.allAttch[index - 1] = temp;
      
      localStorage.setItem('bienImage', JSON.stringify(this.allAttch));
    }
  }

  moveImageDown(index: number): void {
    if (index < this.allAttch.length - 1) {
      const temp = this.allAttch[index];
      this.allAttch[index] = this.allAttch[index + 1];
      this.allAttch[index + 1] = temp;
      
      localStorage.setItem('bienImage', JSON.stringify(this.allAttch));
    }
  }

  removePromoImage(): void {
    if (this.promoAttch.length === 0) return;
    
    const imageUrl = this.promoAttch[0];
    
    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Voulez-vous vraiment supprimer l'image promotionnelle?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        // Delete from S3
        this.awsService.deleteFile(imageUrl).subscribe({
          next: (response: DeleteResponse) => {
            if (response.status === 'success') {
              this.promoAttch = [];
              this.imagePromo = '';
              localStorage.removeItem('promoBien');
              
              Swal.fire({
                icon: "success",
                title: "Image supprimée",
                text: "L'image promotionnelle a été supprimée avec succès",
                timer: 2000,
                showConfirmButton: false
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erreur",
                text: response.error || "Échec de la suppression de l'image",
              });
            }
          },
          error: (err: any) => {
            console.error('Error deleting promo image:', err);
            Swal.fire({
              icon: "error",
              title: "Erreur",
              text: "Échec de la suppression de l'image. Veuillez réessayer.",
            });
          }
        });
      }
    });
  }

  clearStoredImages(): void {
    // Note: This only clears local storage, not S3
    // If you want to delete from S3 on component destroy, you'd need to iterate through arrays
    localStorage.removeItem('bienImage');
    localStorage.removeItem('promoBien');
    this.allAttch = [];
    this.promoAttch = [];
    this.imagePromo = '';
  }

  // Agency methods
  retrieveStoredItemId() {
    const storedItemId = localStorage.getItem('storedItemId');
    this.idItem = storedItemId;
    console.log('Stored Item ID:', this.idItem);
  }

  AgencyNameById() {
    if (this.idA) {
      this.agenciesService.getAgencieById(this.idA).subscribe((data: any) => {
        this.NameAgence = data.name;
        console.log('Agency Name by ID:', this.NameAgence);
      });
    }
  }

  AgencyNameById1() {
    if (this.idItem) {
      this.agenciesService.getAgencieById(this.idItem).subscribe((data: any) => {
        this.NameAgence1 = data.name;
        console.log('Agency Name 1:', this.NameAgence1);
      });
    }
  }

  // Form submission
  validateYouTubeUrl(url: string): boolean {
    if (!url) return true; // Optional field
    
    const youtubePattern = /^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return youtubePattern.test(url);
  }

  onSubmit() {
    // Validation
    if (!this.biensImmob.name || !this.biensImmob.description || !this.selectedAgencyName) {
      Swal.fire({
        icon: 'warning',
        title: 'Champs requis',
        text: 'Veuillez remplir tous les champs obligatoires (Nom, Description, Agence)'
      });
      return;
    }

    if (this.biensImmob.videoUrlBien && !this.validateYouTubeUrl(this.biensImmob.videoUrlBien)) {
      Swal.fire({
        icon: 'error',
        title: 'URL YouTube invalide',
        text: 'Veuillez entrer une URL YouTube valide'
      });
      return;
    }

    if (this.allAttch.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Image requise',
        text: 'Veuillez ajouter au moins une image du bien'
      });
      return;
    }

    this.biens = {
      "name": this.biensImmob.name,
      "description": this.biensImmob.description,
      "prix": this.biensImmob.prix,  
      "agencyName": this.selectedAgencyName,   
      "categoryList": this.biensImmob.categoryList || [],  
      "imageUrl": this.allAttch[0], // Main image
      "promoTitle": this.biensImmob.promoTitle,
      "type": this.biensImmob.type,  
      "role": this.biensImmob.role,
      "videoUrlBien": this.biensImmob.videoUrlBien,  
      "promoImg": this.promoAttch.length > 0 ? this.promoAttch[0] : '',
      "nomCommercial": this.biensImmob.nomCommercial,
      "numCommercial": this.biensImmob.numCommercial,
      "emailCommercial": this.biensImmob.emailCommercial
    };

    console.log('Data to submit:', this.biens);

    this.bienImmobService.createBiensImmobs(this.biens).subscribe(
      () => {
        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Le bien immobilier a été créé avec succès",
        }).then(() => {
          this.clearStoredImages();
          this.location.back();
        });
      },
      (error) => {
        console.error('Error creating property:', error);
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Échec de la création du bien immobilier. Veuillez réessayer.",
        });
      }
    );
  }
}